// 不再使用，详见car_strand.js
import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/car/stranded/list',
    method: 'post',
    data,
  })
}
export async function getDetail(params) {
  return request({
    url: '/car/stranded/detail',
    method: 'get',
    params,
  })
}
export async function alarmDeal(data) {
  return request({
    url: '/car/stranded/alarmDeal',
    method: 'post',
    data,
  })
}